"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowGroup = exports.CloseButton = exports.Thumbnail = exports.GalleryScroll = exports.Image = exports.ImageTitle = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  background: rgb(123, 123, 123);
  border-radius: 15px;
  position: relative;
  user-select: none;
`;
exports.ImageTitle = styled_components_1.default.div `
  position: absolute;
  top: 15%;
  left: 0;
  font-size: 20px;
  font-family: 'Rubik';
  background: #ac1841;
  border-radius: 0 20px 20px 0;
  color: #fff;
  padding: 15px;
  span {
    font-weight: 500;
    font-family: 'Rubik Medium';
  }
`;
exports.Image = styled_components_1.default.div `
  width: 100%;
  height: 100%;
  border-radius: 15px;
  background: url(${(props) => props.url});
  background-size: cover;
`;
exports.GalleryScroll = styled_components_1.default.div `
  position: absolute;
  bottom: 5px;
  left: 50%;
  width: 97%;
  transform: translateX(-50%);
`;
exports.Thumbnail = styled_components_1.default.div `
  min-width: 75px;
  height: 75px;
  margin: 2px;
  background: url(${(props) => props.url});
  background-size: cover;
  border: 5px solid white;
  border-radius: 15px 15px 15px 0;
`;
exports.CloseButton = styled_components_1.default.span `
  position: absolute;
  top: -20px;
  right: -10px;
  z-index: 130;
  color: #fff;
  cursor: pointer;
`;
exports.ArrowGroup = styled_components_1.default.div `
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  justify-content: space-between;
  display: flex;
  color: #fff;
  span {
    font-size: 35px;
    cursor: pointer;
  }
`;
